import React from 'react';
import ReactDOM from 'react-dom';
// import { ConnectedRouter as Router } from 'connected-react-router';
import { store, history } from "./store";
import { Provider } from "react-redux";

import { GlobalStyle } from './styling/global';
import RootView from './features/RootView';
import { MemoryRouter as Router } from 'react-router-dom';
import { OFFICE_SERVERS__ROOT, OFFICE_SERVERS__AUDIT_LOGS } from './features/Routes';

import './styling/fonts.css';

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />

    <Provider store={store}>

      <Router
        initialEntries={[OFFICE_SERVERS__ROOT]}
        initialIndex={0}
        
      >
        <RootView />
      </Router>

    </Provider>

  </React.StrictMode>,
  document.getElementById('root')
);

